import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { api } from 'constants/api';
import { ApiError, ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type EditCampaignResponseType = {};

type EditCampaignParams = {
  schedule_id: string;
  data: {
    scheduled_time: number;
  };
};

export const useEditCampaign = (
  options?: MutationOptions<
    EditCampaignResponseType,
    EditCampaignParams,
    AxiosError<ApiError>
  >
) =>
  useMutation({
    mutationFn: async ({ schedule_id, data: campaignData }) => {
      const { data } = await api.patch<ApiResponse<EditCampaignResponseType>>(
        `/campaign/scheduled/${schedule_id}`,
        campaignData
      );

      return data.data;
    },

    ...options,
  });
